"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_SERVICE_ITEM_ON_LIST = exports.UPDATE_HEADER = exports.UPDATE_CLIENT_ITEM_ON_LIST = exports.TOGGLE_SIDEBAR = exports.TOGGLE_DEVICE = exports.SET_USERS_LIST = exports.SET_TYPES_PERSONS = exports.SET_TYPES_INVESTIDOR_PROFILES = exports.SET_TYPES_APPLICATION_PROFILES = exports.SET_TYPES_ADMINISTRATOR_PROFILES = exports.SET_TOTAL_OPEN_PROTOCOLS = exports.SET_TOKEN = exports.SET_TEXT_LOADING = exports.SET_SIZE = exports.SET_SERVICE_TYPES_LIST = exports.SET_SERVICE_NEW_ITEM = exports.SET_SERVICE_LIST_CLIENT = exports.SET_SERVICE_LIST_ALL = exports.SET_SERVICE_DOCUMENTATION_SANDBOX = exports.SET_SERVICE_DOCUMENTATION = exports.SET_SERVICE_DETAIL_ITEM = exports.SET_SERVICES_MONITOR_PER_TYPE = exports.SET_SERVICES_MONITOR_LIST = exports.SET_ROLES = exports.SET_REQUESTS_CONSUMPTION = exports.SET_PERSONAL_ACCOUNTS = exports.SET_PEOPLE_ANALYSIS = exports.SET_PAGES_LIST = exports.SET_OFFICER_LIST = exports.SET_NAME = exports.SET_MUNICIPIO = exports.SET_MENU_ACCESS = exports.SET_LOADING = exports.SET_LIST_LOG_FILES = exports.SET_LIST_LAST_RESULTS = exports.SET_LIST_CONSUMPTION = exports.SET_INTRODUCTION = exports.SET_FUNDS_LIST = exports.SET_DOCUMENT_CLIENT_LIST = exports.SET_DOCUMENTS_LIST = exports.SET_DETAIL_OPEN_DASHBOARD = exports.SET_CUSTOM_ONBOARDING = exports.SET_CRITERIO_CONFEDERECAO = exports.SET_CRITERIO_ASSOCIACAO = exports.SET_COUNT_REQUEST_PER_TYPE = exports.SET_COOPERATIVAS = exports.SET_CONSORTIUM_CUSTOMERS = exports.SET_CONSORTIUM_CONTRACTS = exports.SET_CONNECTIONS_LIST = exports.SET_CLIENT_NEW_ITEM = exports.SET_CLIENT_ITEM = exports.SET_CLIENTS_LIST = exports.SET_CHANNEL_LIST = exports.SET_CENTRAL_CONF = exports.SET_CENTRAL = exports.SET_BUSINES_UNITS_LIST_ONBOARDING = exports.SET_BUSINES_UNITS_LIST_NAMES = exports.SET_BUSINES_UNITS_LIST = exports.SET_BOND_STRENGTH_LIST = exports.SET_BILLING_MONTH = exports.SET_AVATAR = exports.SET_ASSETS_TYPES_LIST = exports.SET_ASSETS_LIST = exports.SET_ASSETS_ITEM = exports.SET_ANALYTIC_DATA = exports.SET_ALL_PROVIDERS = exports.SET_ALL_CONSUMERS_NOT_LINK = exports.SET_ALL_CONSUMERS_AUTHORIZATIONS = exports.SET_ALL_CONSUMERS = exports.SET_ACESSOS_LIST = exports.SET_ACCESS_GROUP_LIST = exports.RESET_REGISTRATION_FORM = exports.RESET_MONITOR_STATE = exports.RESET_ASSETS_STATE = exports.JOIN_REGISTRATION_FORM = exports.JOIN_FORM_COOPERATIVAS_CREATE = exports.GET_OFFICER_ALL = exports.GET_COMPANY = exports.FILTER_STATUS_LIFE_PROOF = exports.FILTER_ORGANIZATION_LIFE_PROOF = exports.FILTER_BUSINESS_LIFE_PROOF = exports.CLOSE_SIDEBAR = void 0;
// APP
var TOGGLE_SIDEBAR = exports.TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
var CLOSE_SIDEBAR = exports.CLOSE_SIDEBAR = 'CLOSE_SIDEBAR';
var TOGGLE_DEVICE = exports.TOGGLE_DEVICE = 'TOGGLE_DEVICE';
var SET_SIZE = exports.SET_SIZE = 'SET_SIZE';
var SET_LOADING = exports.SET_LOADING = 'SET_LOADING';
var SET_TEXT_LOADING = exports.SET_TEXT_LOADING = 'SET_TEXT_LOADING';
var UPDATE_HEADER = exports.UPDATE_HEADER = 'UPDATE_HEADER';
var SET_MENU_ACCESS = exports.SET_MENU_ACCESS = 'SET_MENU_ACCESS';

// USER
var SET_TOKEN = exports.SET_TOKEN = 'SET_TOKEN';
var SET_INTRODUCTION = exports.SET_INTRODUCTION = 'SET_INTRODUCTION';
var SET_NAME = exports.SET_NAME = 'SET_NAME';
var SET_AVATAR = exports.SET_AVATAR = 'SET_AVATAR';
var SET_ROLES = exports.SET_ROLES = 'SET_ROLES';
var SET_TYPES_PERSONS = exports.SET_TYPES_PERSONS = 'SET_TYPES_PERSONS';
var SET_TYPES_APPLICATION_PROFILES = exports.SET_TYPES_APPLICATION_PROFILES = 'SET_TYPES_APPLICATION_PROFILES';
var SET_TYPES_INVESTIDOR_PROFILES = exports.SET_TYPES_INVESTIDOR_PROFILES = 'SET_TYPES_INVESTIDOR_PROFILES';
var SET_TYPES_ADMINISTRATOR_PROFILES = exports.SET_TYPES_ADMINISTRATOR_PROFILES = 'SET_TYPES_ADMINISTRATOR_PROFILES';
var JOIN_REGISTRATION_FORM = exports.JOIN_REGISTRATION_FORM = 'JOIN_REGISTRATION_FORM';
var RESET_REGISTRATION_FORM = exports.RESET_REGISTRATION_FORM = 'RESET_REGISTRATION_FORM';

// Files
var SET_CLIENTS_LIST = exports.SET_CLIENTS_LIST = 'SET_CLIENTS_LIST';
var SET_CLIENT_ITEM = exports.SET_CLIENT_ITEM = 'SET_CLIENT_ITEM';
var SET_DOCUMENT_CLIENT_LIST = exports.SET_DOCUMENT_CLIENT_LIST = 'SET_DOCUMENT_CLIENT_LIST';
var SET_CLIENT_NEW_ITEM = exports.SET_CLIENT_NEW_ITEM = 'SET_CLIENT_NEW_ITEM';
var UPDATE_CLIENT_ITEM_ON_LIST = exports.UPDATE_CLIENT_ITEM_ON_LIST = 'UPDATE_CLIENT_ITEM_ON_LIST';

// Assets
var SET_ASSETS_LIST = exports.SET_ASSETS_LIST = 'SET_ASSETS_LIST';
var SET_ASSETS_ITEM = exports.SET_ASSETS_ITEM = 'SET_ASSETS_ITEM';
var SET_ASSETS_TYPES_LIST = exports.SET_ASSETS_TYPES_LIST = 'SET_ASSETS_TYPES_LIST';

// Documents
var SET_DOCUMENTS_LIST = exports.SET_DOCUMENTS_LIST = 'SET_DOCUMENTS_LIST';

// Funds
var SET_FUNDS_LIST = exports.SET_FUNDS_LIST = 'SET_FUNDS_LIST';

// Acessos
var SET_ACESSOS_LIST = exports.SET_ACESSOS_LIST = 'SET_ACESSOS_LIST';

// Table
var SET_CENTRAL = exports.SET_CENTRAL = 'SET_CENTRAL';
var SET_CRITERIO_ASSOCIACAO = exports.SET_CRITERIO_ASSOCIACAO = 'SET_CRITERIO_ASSOCIACAO';
var SET_CRITERIO_CONFEDERECAO = exports.SET_CRITERIO_CONFEDERECAO = 'SET_CRITERIO_CONFEDERECAO';
var SET_CENTRAL_CONF = exports.SET_CENTRAL_CONF = 'SET_CENTRAL_CONF';
var SET_CHANNEL_LIST = exports.SET_CHANNEL_LIST = 'SET_CHANNEL_LIST';
var SET_OFFICER_LIST = exports.SET_OFFICER_LIST = 'SET_OFFICER_LIST';

// Cooperativas
var SET_COOPERATIVAS = exports.SET_COOPERATIVAS = 'SET_COOPERATIVAS';
var JOIN_FORM_COOPERATIVAS_CREATE = exports.JOIN_FORM_COOPERATIVAS_CREATE = 'JOIN_FORM_COOPERATIVAS_CREATE';

// Municipios
var SET_MUNICIPIO = exports.SET_MUNICIPIO = 'SET_MUNICIPIO';

// Companhia
var GET_COMPANY = exports.GET_COMPANY = 'GET_COMPANY';

// officer
var GET_OFFICER_ALL = exports.GET_OFFICER_ALL = 'GET_OFFICER_ALL';

// PRODUCTS
var SET_CONNECTIONS_LIST = exports.SET_CONNECTIONS_LIST = 'SET_CONNECTIONS_LIST';

// CONSUMERS
var SET_ALL_CONSUMERS = exports.SET_ALL_CONSUMERS = 'SET_ALL_CONSUMERS';
var SET_ALL_CONSUMERS_NOT_LINK = exports.SET_ALL_CONSUMERS_NOT_LINK = 'SET_ALL_CONSUMERS_NOT_LINK';
var SET_ALL_CONSUMERS_AUTHORIZATIONS = exports.SET_ALL_CONSUMERS_AUTHORIZATIONS = 'SET_ALL_CONSUMERS_AUTHORIZATIONS';

// PROVIDERS
var SET_ALL_PROVIDERS = exports.SET_ALL_PROVIDERS = 'SET_ALL_PROVIDERS';

// BUSINES UNITS
var SET_BUSINES_UNITS_LIST = exports.SET_BUSINES_UNITS_LIST = 'SET_BUSINES_UNITS_LIST';

// Users
var SET_USERS_LIST = exports.SET_USERS_LIST = 'SET_USERS_LIST';

// SERVICES
var SET_SERVICE_LIST_ALL = exports.SET_SERVICE_LIST_ALL = 'SET_SERVICE_LIST_ALL';
var SET_SERVICE_DETAIL_ITEM = exports.SET_SERVICE_DETAIL_ITEM = 'SET_SERVICE_DETAIL_ITEM';
var SET_SERVICE_LIST_CLIENT = exports.SET_SERVICE_LIST_CLIENT = 'SET_SERVICE_LIST_CLIENT';
var SET_SERVICE_TYPES_LIST = exports.SET_SERVICE_TYPES_LIST = 'SET_SERVICE_TYPES_LIST';
var SET_SERVICE_DOCUMENTATION = exports.SET_SERVICE_DOCUMENTATION = 'SET_SERVICE_DOCUMENTATION';
var SET_SERVICE_DOCUMENTATION_SANDBOX = exports.SET_SERVICE_DOCUMENTATION_SANDBOX = 'SET_SERVICE_DOCUMENTATION_SANDBOX';
var SET_SERVICE_NEW_ITEM = exports.SET_SERVICE_NEW_ITEM = 'SET_SERVICE_NEW_ITEM';
var UPDATE_SERVICE_ITEM_ON_LIST = exports.UPDATE_SERVICE_ITEM_ON_LIST = 'SET_SERVICE_NEW_ITEM_ON_LIST';
var RESET_ASSETS_STATE = exports.RESET_ASSETS_STATE = 'RESET_ASSETS_STATE';

//  DASHBOARD
var SET_LIST_CONSUMPTION = exports.SET_LIST_CONSUMPTION = 'SET_LIST_CONSUMPTION';
var SET_LIST_LAST_RESULTS = exports.SET_LIST_LAST_RESULTS = 'SET_LIST_LAST_RESULTS';
var SET_DETAIL_OPEN_DASHBOARD = exports.SET_DETAIL_OPEN_DASHBOARD = 'SET_DETAIL_OPEN_DASHBOARD';
var SET_REQUESTS_CONSUMPTION = exports.SET_REQUESTS_CONSUMPTION = 'SET_REQUESTS_CONSUMPTION';
var SET_TOTAL_OPEN_PROTOCOLS = exports.SET_TOTAL_OPEN_PROTOCOLS = 'SET_TOTAL_OPEN_PROTOCOLS';

// BILLING
var SET_BILLING_MONTH = exports.SET_BILLING_MONTH = 'SET_BILLING_MONTH';

// Monitor Type Services
var SET_SERVICES_MONITOR_PER_TYPE = exports.SET_SERVICES_MONITOR_PER_TYPE = 'SET_SERVICES_MONITOR_PER_TYPE';
var SET_COUNT_REQUEST_PER_TYPE = exports.SET_COUNT_REQUEST_PER_TYPE = 'SET_COUNT_REQUEST_PER_TYPE';
var SET_SERVICES_MONITOR_LIST = exports.SET_SERVICES_MONITOR_LIST = 'SET_SERVICES_MONITOR_LIST';
var RESET_MONITOR_STATE = exports.RESET_MONITOR_STATE = 'RESET_MONITOR_STATE';

// People Analysis
var SET_PEOPLE_ANALYSIS = exports.SET_PEOPLE_ANALYSIS = 'SET_PEOPLE_ANALYSIS';

// Open Bankin - BBTS
var SET_PERSONAL_ACCOUNTS = exports.SET_PERSONAL_ACCOUNTS = 'SET_PERSONAL_ACCOUNTS';

// Audit - Auditoria
var SET_LIST_LOG_FILES = exports.SET_LIST_LOG_FILES = 'SET_LIST_LOG_FILES';

// CUSTOM ONBOARDING
var SET_BUSINES_UNITS_LIST_ONBOARDING = exports.SET_BUSINES_UNITS_LIST_ONBOARDING = 'SET_BUSINES_UNITS_LIST_ONBOARDING';
var SET_BUSINES_UNITS_LIST_NAMES = exports.SET_BUSINES_UNITS_LIST_NAMES = 'SET_BUSINES_UNITS_LIST_NAMES';
var SET_CUSTOM_ONBOARDING = exports.SET_CUSTOM_ONBOARDING = 'SET_CUSTOM_ONBOARDING';

// FORÇA DE VINCULO
var SET_BOND_STRENGTH_LIST = exports.SET_BOND_STRENGTH_LIST = 'SET_BOND_STRENGTH_LIST';

// ANALYTICS
var SET_ANALYTIC_DATA = exports.SET_ANALYTIC_DATA = 'SET_ANALYTIC_DATA';

// ACCESS GROUPS
var SET_PAGES_LIST = exports.SET_PAGES_LIST = 'SET_PAGES_LIST';
var SET_ACCESS_GROUP_LIST = exports.SET_ACCESS_GROUP_LIST = 'SET_ACCESS_GROUP_LIST';

// CONSORTIUM
var SET_CONSORTIUM_CUSTOMERS = exports.SET_CONSORTIUM_CUSTOMERS = 'SET_CONSORTIUM_CUSTOMERS';
var SET_CONSORTIUM_CONTRACTS = exports.SET_CONSORTIUM_CONTRACTS = 'SET_CONSORTIUM_CONTRACTS';

// LIVENESS
var FILTER_BUSINESS_LIFE_PROOF = exports.FILTER_BUSINESS_LIFE_PROOF = 'FILTER_BUSINESS_LIFE_PROOF';
var FILTER_ORGANIZATION_LIFE_PROOF = exports.FILTER_ORGANIZATION_LIFE_PROOF = 'FILTER_ORGANIZATION_LIFE_PROOF';
var FILTER_STATUS_LIFE_PROOF = exports.FILTER_STATUS_LIFE_PROOF = 'FILTER_STATUS_LIFE_PROOF';